import type { FeatureGroup } from '../../../../types';
import { ASSETS_FEATURE_GROUP } from '../group';

export const ASSETS_COLORS_FEATURE_GROUP: FeatureGroup = {
  guid: 'f1d5e739-7c2a-4b18-a462-3b9c0f5dff00',
  name: 'assets:colors',
  description: 'Color asset features — organization color scheme settings',
  product: 'account',
  parentGuid: ASSETS_FEATURE_GROUP.guid,
};
